<fcom-modal
  *ngIf="openModal$ | async as modal"
  [open]="modal.open"
  [title]="modal.title | finLocalization"
  [buttons]="modal.buttons"
  (close)="closeModal()"
  (confirm)="confirmModal()"
>
  <cms-unstyled-fragment
    *ngIf="modal.fragment | finLocalization as fragment"
    class="block pr-medium-x pr-medium-y"
    [contentUrl$]="fragment | finToObservable"
  >
  </cms-unstyled-fragment>
</fcom-modal>
